import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import './authorized.scss';
import { loadTransportList } from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { getProfileData } from '../reducer';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { applicantTypeFormatter, infoFormatterIntl } from '../../../utils/formatters';
import Grid from '../../../components/base/Grid/Grid';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import Pagination from '../../../components/base/Pagination/Pagination';
import { FilterForm } from './FilterForm';

export function UserOrganizationItem(props) {
  const {
    item = {

    },
  } = props;

  const columns = [
    {
      dataField: 'brand',
      text: 'Марка ТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'model',
      text: 'Модель ТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'color',
      text: 'Цвет ТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'license_plate',
      text: 'ГРН ТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'year',
      text: 'Год выпуска',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'vin',
      text: 'VIN',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'sts',
      text: 'СТС',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'ecology',
      text: 'Э.Класс',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'registry',
      text: 'Реестр',
      disableSort: true,
      dataClassName: 'align-middle',
      hidden: true,
      disablePosition: false,
    },
    {
      dataField: 'applicant_type',
      text: 'Заявитель',
      disableSort: true,
      dataClassName: 'align-middle',
      formatter: applicantTypeFormatter,
      hidden: true,
      disablePosition: false,
    },
  ];
  const [selected, setSelected] = useState(1);
  const dispatch = useDispatch();

  const {
    control,
  } = useForm({
    defaultValues: {},
  });

  const transportList = [];

  // const {
  //   transportList,
  // } = useSelector(getProfileData);
  //
  // useEffect(() => {
  //   dispatch(loadTransportList({
  //     filter: {
  //       name: item?.name,
  //     },
  //   })).catch(responseLogWithNotification);
  // }, []);

  return (
    <div className="uspd-organization-box">
      <div className="uspd-organization-box-tabs">
        <div className={classNames('uspd-organization-box-tab', { isActive: selected })} onClick={() => setSelected(1)}>Основная информация</div>
        <div className={classNames('uspd-organization-box-tab', { isActive: !selected })} onClick={() => setSelected(0)}>Транспортные средства организации</div>
      </div>
      <div className="uspd-organization-box-content">
        {selected ? (
          <div className="uspd-organization-box-info">
            <Row className="row-cols-3">
              {infoFormatterIntl('user.short_name', item.short_name, {}, 'organization.short_name')}
              {infoFormatterIntl('user.organization_type', item.type_orgnization, {}, 'user.organization_type')}
              {infoFormatterIntl('user.ogrn', item.ogrn, {}, 'organization.ogrn')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.inn', item?.inn, {}, 'organization.inn')}
              {infoFormatterIntl('user.kpp', item?.kpp, {}, 'organization.kpp')}
              {infoFormatterIntl('user.oktmo', item.oktmo, {}, 'organization.oktmo')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.phone', item.phone, {}, 'organization.phone')}
              {infoFormatterIntl('user.fax', item.fax, {}, 'organization.fax')}
              {infoFormatterIntl('user.email', item.email, {}, 'organization.email')}
            </Row>
            <div className="f4">Почтовый адрес</div>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_index', item.index, {}, 'address.index')}
              {infoFormatterIntl('user.postal_country_id', item.country_id, {}, 'address.country_id')}
              {infoFormatterIntl('user.postal_fias_code', item.fias_code, {}, 'address.fias_code')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_region', item.region, {}, 'address.region')}
              {infoFormatterIntl('user.postal_city', item.city, {}, 'address.city')}
              {infoFormatterIntl('user.postal_address', item.address, {}, 'address.address')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_building', item.building, {}, 'address.building')}
              {infoFormatterIntl('user.postal_corpus', item.corpus, {}, 'address.corpus')}
              {infoFormatterIntl('user.postal_house', item.house, {}, 'address.house')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_apartment', item.apartment, {}, 'address.apartment')}
              {infoFormatterIntl('address.area', item.address_area, {}, 'address.address.area')}
              {infoFormatterIntl('user.postal_settlement', item.settlement, {}, 'address.settlement')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_extra_territory', item.extra_territory, {}, 'address.extra_territory')}
              {infoFormatterIntl('user.postal_extra_street', item.extra_street, {}, 'address.extra_street')}
            </Row>
            <div className="f4">Юридический адрес</div>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_index', item.index, {}, 'address.index')}
              {infoFormatterIntl('user.postal_country_id', item.country_id, {}, 'address.country_id')}
              {infoFormatterIntl('user.postal_fias_code', item.fias_code, {}, 'address.fias_code')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_region', item.region, {}, 'address.region')}
              {infoFormatterIntl('user.postal_city', item.city, {}, 'address.city')}
              {infoFormatterIntl('user.postal_address', item.address, {}, 'address.address')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_building', item.building, {}, 'address.building')}
              {infoFormatterIntl('user.postal_corpus', item.corpus, {}, 'address.corpus')}
              {infoFormatterIntl('user.postal_house', item.house, {}, 'address.house')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_apartment', item.apartment, {}, 'address.apartment')}
              {infoFormatterIntl('address.area', item.address_area, {}, 'address.address.area')}
              {infoFormatterIntl('user.postal_settlement', item.settlement, {}, 'address.settlement')}
            </Row>
            <Row className="row-cols-3">
              {infoFormatterIntl('user.postal_extra_territory', item.extra_territory, {}, 'address.extra_territory')}
              {infoFormatterIntl('user.postal_extra_street', item.extra_street, {}, 'address.extra_street')}
            </Row>
          </div>
        ) : (
          <div className="uspd-organization-box-table">
            <div className="uspd-organization-box-table-filter">
              <FieldDTO
                control={control}
                component={TextInput}
                dtoObject={{
                  name: 'search',
                  type: String,
                  labelKey: 'search',
                }}
                inputBefore={(
                  <div className="search-wrapper">
                    <Icons customIcon className="search" width={24} height={24} icon="search" />
                  </div>
                )}
                inputProps={{
                  // value: search || getValues('search') || '',
                  // onChange: e => handleSetUrlParams({ procedures: procedureText, search: e.target.value || '' }),
                }}
              />
              <FilterForm control={control} />
            </div>
            <div>
              <Grid data={transportList} columns={columns} />
              <Pagination list={[]} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
